import { useABTestingStore } from '@/store-pinia/abtesting'
import { GOOGLE_BUSINESS_VERTICAL } from '@/constants/ads'
import { GtmEventMap } from '@/view-models/gtm'

interface GTMListItem {
  product_id?: number
  bid?: number
  name: string
  price: number
  list_price: number
  position: number
}

export function useGTMViewItemList() {
  const nuxtApp = useNuxtApp()
  const aBTestingStore = useABTestingStore()
  const isBranchCardMode = computed(() => aBTestingStore.cardMode === 'branch')

  const branchesInfo = computed(() => nuxtApp.$store.getters['branch/branchesInfo'])
  const categoryProductInfo = computed(() => nuxtApp.$store.getters['product/categoryProductInfo'])

  const gtmListData = computed(() => {
    const list = isBranchCardMode.value ? branchesInfo.value.branches : categoryProductInfo.value.products
    return list.map((item: GTMListItem) => ({
      id: `${item.product_id || item.bid || 0}`,
      google_business_vertical: GOOGLE_BUSINESS_VERTICAL,
    }))
  })
  const isMounted = useMounted()

  function sendGTMViewItemList() {
    if (isMounted.value) {
      nuxtApp.$gtm.push({ event: GtmEventMap.VIEW_ITEM_LIST, value: 0, items: gtmListData.value })
    }
  }

  return {
    sendGTMViewItemList,
  }
}
